<template lang='pug'>
  blue-layout(:user='user' :account='account' :biz='biz')
    #pricetable.view
      bf-wrapper.centered
        h3 {{$t("Price Table")}}
        .table-container
          table.price
            tr
              th
              th {{$t("Consumer")}}
              th {{$t("Basic Seller")}}
              th {{$t("Value Merchant")}}
            tr.orange
              td.title {{$t("Monthly Fee")}}
              td {{$t("Free")}}
              td {{$t("Free")}}
              td $15
            tr
              td.title.red {{$t("# of Reservations/Mon")}}
              td
              td.red 10
              td.red {{$t("Unlimited")}}
            tr
              td.title {{$t("Smart Calendar")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
            tr 
              td.title {{$t("Online Booking/Order")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
            tr
              td.title {{$t("Referral Program")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
            tr
              td.title {{$t("Refer A Friend")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
            tr
              td.title {{$t("Transaction History")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
            tr
              td.title {{$t("Notification")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
            tr
              td.title {{$t("Favoited Stores Keeping")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
            tr
              td.title {{$t("Coupons")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
              td {{$t("Yes")}}
            tr
              td(v-bind:colspan="4")
            tr
              td.title.red {{$t("Real Time Status")}}
              td 
              td.red {{$t("Yes")}}
              td.red {{$t("Yes")}}
            tr
              td.title.red {{$t("Customer database")}}
              td 
              td.red {{$t("Yes")}}
              td.red {{$t("Yes")}}
            tr
              td.title.red {{$t("Customer category")}}
              td 
              td.red {{$t("Yes")}}
              td.red {{$t("Yes")}}
            tr
              td.title.red {{$t("Customer type")}}
              td 
              td.red {{$t("Yes")}}
              td.red {{$t("Yes")}}
            tr
              td.title.red {{$t("BlueFaucet Page & Link")}}
              td 
              td.red {{$t("Yes")}}
              td.red {{$t("Yes")}}
            tr
              td.title.red {{$t("Customized Promotion")}}
              td 
              td.red {{$t("Yes")}}
              td.red {{$t("Yes")}}
            tr
              td(v-bind:colspan="4")
            tr
              td.title.red {{$t("Multiple events in the same time")}}
              td 
              td 
              td.red {{$t("Yes")}}
            tr
              td.title.red {{$t("Customize Landing page")}}
              td 
              td 
              td.red {{$t("Yes")}}
            tr
              td.title.red {{$t("Product Menu/Catalog")}}
              td 
              td 
              td.red {{$t("Yes")}}
            tr
              td(v-bind:colspan="4") 
                bf-button.wide(v-if="!account.id" @click.native='$router.push({ name: "sign-up"})')
                  template(v-slot:text) {{$t("Sign Up")}}
                bf-button.wide(v-if="account.id && !account.merchant" @click.native='$router.push({ name: "upgrade"})')
                  template(v-slot:text) {{$t("Start Selling")}}
                bf-button.wide( 
                  v-if='account.merchant=="basic"'
                  @click.native='$router.push({ name: "account", params: { preset: "value" } })'
                )
                  template( v-slot:text ) {{ $t( "Upgrade to Value Merchant" ) }}
        
</template>

<script>
  import { View } from '@/mixins/view'
  import { db } from '@/main'
  
  export default {
    name: 'pricetable.view',

    mixins: [View]
  }
</script>

<style scoped lang='stylus'>
  .bf-button.wide
    margin-right 10px
  .table-container
    border-radius 5px
    border 1px solid rgba( 0 0 0 .25 )
    overflow hidden
    margin-top 20px

  table
    background white
    border 1px solid gray
    border-radius 5px
    padding 10px
    text-align center
    width 100%
    .price
      text-align center
  th
    background gray
    color white
    font-weight bold
    font-size 1.2em
    border 1px solid darkgray
    padding 10px
  td
    padding 10px
    border 1px solid lightgray
    
  .title
    text-align right
    font-weight bold
  .red
    font-weight bold
    color red
  .orange
    background lightblue
    font-weight bold
    font-size 1.2em
    color red
</style>
